import React from "react";

import OfferIcon from "@components/icons/Offer";
import { cdn } from "@data-types/offer/prematch/PrematchHeaderTypes";
import TopTournamentMenuIcons from "@features/offer/shared/icon/TopTournamentMenuIcons";
import classNames from "classnames";
import { observer } from "mobx-react";

export default observer(function PageHeaderTitle(props: {
	store: {
		getHeaderInfo: {
			name: string;
			cdnData?: cdn | undefined;
			isMultiSport?: boolean | undefined;
		} | null;
	};
}) {
	const iconWrapper = "header__icon u-icon u-icon--med";
	const iconBase = "header__icon__inner u-icon--base";

	const nameAndIcon = props.store.getHeaderInfo;
	if (nameAndIcon == null) {
		return null;
	}

	return (
		<>
			<div className="header__icons">
				{nameAndIcon.cdnData?.parent ? (
					nameAndIcon.cdnData?.parent.isTopTournament ? (
						<>
							<TopTournamentMenuIcons
								key={nameAndIcon.cdnData?.parent.name}
								sportAbrv={
									nameAndIcon.cdnData?.parent.sport || ""
								}
								tournamentAbrv={
									nameAndIcon.cdnData?.parent.sport || ""
								}
								isSpecialOffer={
									nameAndIcon.cdnData.isSpecialOffer
								}
								className={classNames(
									"header__icon--top",
									iconWrapper
								)}
								imgClassName={iconBase}
							/>
						</>
					) : (
						<>
							<OfferIcon
								type="sport"
								sport={nameAndIcon.cdnData?.parent.sport || ""}
								wrapperClassName={classNames(
									"header__icon--sport",
									iconWrapper
								)}
								className={iconBase}
							/>
						</>
					)
				) : null}
				{nameAndIcon.cdnData?.isTopTournament ? (
					<>
						<TopTournamentMenuIcons
							key={nameAndIcon.name}
							sportAbrv={nameAndIcon.cdnData.sport || ""}
							tournamentAbrv={
								nameAndIcon.cdnData.tournament || ""
							}
							isSpecialOffer={nameAndIcon.cdnData.isSpecialOffer}
							className={classNames(
								"header__icon--top",
								iconWrapper
							)}
							imgClassName={iconBase}
						/>
					</>
				) : (
					<>
						{/* @ts-expect-error */}
						<OfferIcon
							wrapperClassName={classNames(iconWrapper)}
							className={iconBase}
							{...nameAndIcon.cdnData}
						/>
					</>
				)}

				{/* <h1 className="header__title">{nameAndIcon.name}</h1> */}
			</div>

			<div className="header__content header--sub__content">
				{nameAndIcon.cdnData?.parent ? (
					nameAndIcon.cdnData?.isTopTournament ? (
						<div
							className="header__subtitle"
							data-description="nameAndIcon.cdnData.parent.name + isTopTournament"
						>
							{nameAndIcon.cdnData.parent.name}
						</div>
					) : (
						<div
							className="header__subtitle"
							data-description="nameAndIcon.cdnData.parent.name"
						>
							{nameAndIcon.cdnData.parent.name}
						</div>
					)
				) : null}
				<div className="header--sub__inner">
					<h1 className="header__title header--sub__title">
						{nameAndIcon.name}
					</h1>
				</div>
			</div>
		</>
	);
});
